import type { WhoamiMe } from "@shared-domain/auth-service/contract";
import { Loader2 } from "lucide-react";
import type { LoginPageProduct } from "../types";

/**
 * プロダクト選択 UI
 */
export const ProductSelect: React.FC<{
  user: WhoamiMe;
  products: LoginPageProduct[];
  onSelect: (product: LoginPageProduct) => void;
  handleClickLogout: () => void;
}> = ({ user, products, onSelect, handleClickLogout }) => {
  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-4">
      <div className="w-full max-w-md space-y-4">
        <h2 className="text-2xl font-bold text-center mb-4">
          {user.user.name}さん、
          <br />
          プロダクトを選択してください。
        </h2>
        {products.map((p) =>
          p.isLoading ? (
            <div key={`${p.tenantId}_${p.id}_loading`} className="block w-full py-3 px-6 border rounded-lg text-left hover:bg-neutral-50">
              <div className="flex justify-center items-center text-gray-400">
                <Loader2 className="animate-spin" />
                <span className="ml-2">プロダクトに遷移しています...</span>
              </div>
            </div>
          ) : (
            <button
              key={`${p.tenantId}_${p.id}`}
              className="block w-full py-3 px-6 border rounded-lg text-left hover:bg-neutral-50"
              onClick={() => onSelect(p)}
            >
              <span className="text-lg text-primary mr-2">{p.name}</span>
              <span className="text-sm text-gray-500"> {p.tenantName}</span>
            </button>
          ),
        )}
      </div>

      {/* ログアウト */}
      <button
        type="submit"
        onClick={handleClickLogout}
        className={`
          w-80 bg-gray-500 hover:bg-gray-600 text-white
          mt-10 py-3 rounded-2xl text-xl font-bold transition-colors
        `}
      >
        ログアウト
      </button>
    </div>
  );
};
